<ng-container *ngrxLet="isLoading$; let isLoading">
  <div class="container">
    @if (showNoSearch$ | async) {
      <div class="container-empty-state">
        <app-no-search></app-no-search>
      </div>
    }

    @if (showNoHits$ | async) {
      <div class="container-empty-state">
        <app-no-hits></app-no-hits>
      </div>
    }
    @if (isLoading) {
      <div class="search-overlay">
        <p-progressSpinner strokeWidth="2" styleClass="custom-spinner"></p-progressSpinner>
        <div class="search-text">Suche läuft</div>
        <button
          class="cancel-button"
          pButton
          icon="pi pi-times"
          (click)="onCancelSearch()"
          label="Abbrechen"
        ></button>
      </div>
    }

    <div [hidden]="hideHitlist$ | async">
      <div class="hitlist-header">
        <div>
          <h2 class="hitlist-header-title">
            <ng-container *ngrxLet="totalHitCount$; let totalHitCount">
              @if (isLoading) {
                <span>Suche Treffer</span>
              }
              @if (!isLoading) {
                @if ((totalHitCount ?? 0) >= 10000) {
                  <span>Mehr als </span>
                }
                @if (totalHitCount) {
                  <span>{{ totalHitCount | numberSeparator }} Treffer</span>
                }
              }
            </ng-container>
          </h2>
        </div>
        <app-hitlist-controls></app-hitlist-controls>
      </div>
      <ng-container>
        <app-table-hitlist
          [hitlist]="tableHitlist$ | async"
          [isLoadingNextPageIndicator]="isLoadingNextPage"
          [isSearchRestricted]="(areProfileFiltersSet$ | async) === false"
          [lastResponseSearchType]="lastResponseSearchType.value"
        ></app-table-hitlist>
      </ng-container>
    </div>
  </div>
</ng-container>
